import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";
import HCheckArray from "@rf-helper/check-have-value";
import { HGenerateFileData, IFileData } from "@rf-l1/file/helpers/create-file-data";

const prepareDocumentsToClient = (res: IPropertyDetailsResponse) => {
  const documents: {
    title: IFileData[];
    captureDetails: IFileData[];
    fileApplicationForm: IFileData[];
    fileOwnerId: IFileData[];
    filePowerOwnership: IFileData[];
    fileCommercialRegistry: IFileData[];
    filePropertyContract: IFileData[];
  } = {
    title: [],
    captureDetails: [],
    fileApplicationForm: [],
    fileOwnerId: [],
    filePowerOwnership: [],
    fileCommercialRegistry: [],
    filePropertyContract: []
  };

  if (HCheckArray(res?.documents)) {
    res?.documents.forEach(document => {
      const el = HGenerateFileData({
        file: document.filename,
        id: document.id,
        name: document.type.description
      });
      if (!el) {
        return;
      }
      if (document.documenttype_id === 1) {
        documents.title.push(el);
      }
      if (document.documenttype_id === 2) {
        documents.captureDetails.push(el);
      }
      if (document.documenttype_id === 3) {
        documents.fileApplicationForm.push(el);
      }
      if (document.documenttype_id === 4) {
        documents.fileOwnerId.push(el);
      }
      if (document.documenttype_id === 5) {
        documents.fileCommercialRegistry.push(el);
      }
      if (document.documenttype_id === 8) {
        documents.filePowerOwnership.push(el);
      }
      if (document.documenttype_id === 9) {
        documents.filePropertyContract.push(el);
      }
    });
  }

  return documents;
};

export default prepareDocumentsToClient;
